const env = {
  "bo-dev": "https://bo-dev.mapcard.pro",
  "bo-stage": "https://bo-stage.mapisacard.com",
  "bo-evo": "https://bo-evo.mapisacard.com",
  "bo-ab": 'https://identity.abgate.pro',
};

const auth0 = {
  // "dev": "PzB95YCVstd8OHlhEkiR9t22IEnQriK5",
  // "stage": "MiEBa4Mx5TbAFCasxGsLjnm0AUFAbRvL",
  "prod": "2jc4hH10i67vYiCWO9qn0Z4noWxLmcBA"
};

// const auth = {
//   'bo-dev': 'https://auth-stage.cardid.pro',
//   'bo-stage': 'https://auth-stage.cardid.pro',
//   'bo-evo': 'https://auth.cardid.pro'
// }

const auth = {
  // 'bo-stage.mapcard.pro': 'https://auth-stage.cardid.pro',
  'bopay.pay2day.kz': 'https://auth.cardid.pro',
  'bopay.cardteam.ru': 'https://auth.cardid.pro',
  'bopay.abgate.pro': 'https://identity.abgate.pro',
  // 'cabinet-stage.rocketpay.kz ': 'https://auth-stage.cardid.pro',
  // 'cabinet.rocketpay.kz': 'https://auth.cardid.pro',
}
//
// const auth = {
//   'bo-dev': 'https://auth-stage.cardid.pro',
//   'bo-stage': 'https://id-stage.mapcard.pro', // this is a new form url
//   'bo-evo': 'https://auth.cardid.pro'
// }

const origin = window.location.origin;
const hostname = window.location.hostname;
let pathname = window.location.pathname;

let apiUrl = "";
let baseUrl = "";
let clientId = "";
const loginUrl = auth[hostname] || 'https://auth.cardid.pro';

if (hostname && hostname == "localhost") {
  apiUrl = "http://localhost:3001/api/";
  pathname = "/";
  baseUrl = origin + pathname;
  clientId = auth0["stage"];
} else {
  let level = origin.match(/bo-?[a-z]{3,5}/);
  level = level !== null ? level[0] : ''
  if (level == "bodev") {
    //(.com)(\/.*\/)
    pathname = pathname.match(/(\/(feature-.*?|develop))\//)[0];
    console.log("TCL: pathname", pathname);
    apiUrl = "/api" + pathname;
    clientId = auth0["dev"];
  } else {
    apiUrl = "/api/";
    pathname = "/";
    clientId = level == "bopay" ? auth0["prod"] : auth0["stage"];
  }

  baseUrl = origin + pathname;
}

export {
  apiUrl,
  baseUrl,
  pathname,
  clientId,
  loginUrl
};
